import {useTranslation} from "react-i18next";
import {useEffect, useState, useRef} from "react";
import NavBreadcrum from "components/NavBreadcrum";
import ButtonsActions from "views/utils/buttonsActions";
import TopBarActions from "components/TopBarActions";
import OrderingModel from "components/ordering/OrderingModel";
import TableRegistered from "./plugins/TableRegistered";
import {useNavigate} from "react-router-dom";
import PluginModel from "site-apps/plugins/PluginModel";
import FormPlugin from "./plugins/FormPlugin";
import SwalAlert from "core/swalAlert";
import {SwalAlertChoice} from "core/swalClass";
import axiApi from "ApiCaller";
import navs from "./navs";


const buttonsActions = new ButtonsActions();

const ViewPlugins = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tt} = useTranslation("tables");
    const paramsSwalChoice = {
        icon: "info",
        iconColor: "#DD6B55",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: _Tf("labels.delete"),
        cancelButtonText: _Tf("labels.cancel"),
    };
    const swalQuestion = new SwalAlertChoice(paramsSwalChoice);
    const swalShow = new SwalAlert(_Tf("labels.accept"));
    const title = _Tr("labels.plugins");
    const navigate = useNavigate();
    const PluginDefault = new PluginModel();

    const itemsSelected = useRef([]);
    const orderingRef = useRef(new OrderingModel());

    const [items, setItems] = useState([]);
    const [item, setItem] = useState(PluginDefault);
    const [showForm, setShowForm] = useState(false);

    const bread = [
        {name: _Tr("labels.administration"), url: "/administration", current: false},
        {name: _Tr("labels.plugins"), current: true},
    ];
    const [buttonsTB, setButtonsTB] = useState(buttonsActions);
    
    const headersTable = [
        {name: _Tt("common.active"), attr: 0, direction: "asc", active: true, default: true},
        {name: _Tt("common.plugin"), attr: 1, direction: "asc", active: false, disabled: true},
        {name: _Tt("common.actions"), attr: 2, direction: "asc", active: false, disabled: true},
    ];

    const onClickDelete = (e) => {
        swalQuestion.info(_Tf("delete.title"), _Tf("delete.text")).then((resp) => {
            let keys = [],
                plug;
            for (plug of itemsSelected.current) {
                keys.push(plug.key);
            }
            if (resp.isConfirmed) {
                axiApi
                    .post("/api/plugins/delete/", {keys: keys})
                    .then((resp) => {
                        if (resp.data.status) {
                            const result = items.filter((item) => !keys.includes(item));
                            setItems(result);
                            const buttons = {...buttonsTB};
                            buttons.edit.disabled = true;
                            buttons.delete.disabled = true;
                            setButtonsTB(buttons);
                            swalShow.info(_Tf("labels.delete"), _Tf("success.delete"));
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        swalShow.error(_Tf("errors.title"), _Tf("errors.server-error"));
                    });
            }
        });
    };
    const onClickRow = (e) => {
        let checked = e.target.checked;
        let idx = e.target.dataset.idx;
        let itemS = items[idx];
        itemS.idx = idx;
        const buttons = {...buttonsTB};
        if (checked) {
            itemsSelected.current.push(itemS);
        } else {
            itemsSelected.current = itemsSelected.current.filter(
                (el) => el.key !== itemS.key
            );
        }
        buttons.edit.disabled = buttons.delete.disabled = !(
            itemsSelected.current.length === 1
        );
        setButtonsTB(buttons);
        // -
        setItem(itemsSelected.current.length === 1 ? itemS : PluginDefault);
    };
    const onChangeActive = (e) => {
        let idx = e.target.dataset.idx;
        let item = items[idx];
        item.active = !item.active;
        axiApi
            .post("/api/plugin/status/", {key: item.key, active: item.active})
            .then((resp) => {
                if (resp.status === 200) {
                    items[idx] = item;
                    setItems([...items]);
                } else {
                    swalShow.warning(_Tf("errors.title"), _Tf("errors.server-error"));
                }
            })
            .catch((error) => {
                console.error(error);
                swalShow.warning(_Tf("errors.title"), _Tf("errors.server-error"));
            });
    };

    useEffect(() => {
        const buttons = {...buttonsTB};
        buttons.title = title;
        buttons.edit.active = true;
        buttons.edit.onClick = () => {
            setShowForm(true);
        };
        buttons.add.active = true;
        buttons.add.onClick = () => {
            navigate("/administration/plugins/register/");
        };
        buttons.add.disabled = false;
        buttons.delete.active = true;
        buttons.delete.onClick = onClickDelete;
        setButtonsTB({...buttons});
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchPlugins();

        fetchPlugins();
    }, []);

    const fetchPlugins = () => {
        axiApi
            .post("/api/plugins/registered/", {
                params: {
                    ...orderingRef.current.getParams(),
                },
            })
            .then((resp) => {
                if (resp.data) {
                    setItems(resp.data.items);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    return (
        <>
            <FormPlugin
                plugin={item}
                items={items}
                setItems={setItems}
                showForm={showForm}
                setShowForm={setShowForm}
            />
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} />
            <div className="row">
                <div className="col-12">
                    <TableRegistered
                        items={items}
                        onClickRow={onClickRow}
                        onChangeActive={onChangeActive}
                        orderingRef={orderingRef}
                    />
                </div>
            </div>
        </>
    );
};
export default ViewPlugins;
